import { z } from "zod";
import { PERFIS } from "../dominio";
import { email, nome, senhaNova } from "./comuns";

export const usuarioCriarSchema = z.object({
  nome,
  email,
  perfil: z.enum(PERFIS),
  senhaTemporaria: senhaNova,
});
export type UsuarioCriarEntrada = z.input<typeof usuarioCriarSchema>;

export const usuarioEditarSchema = z
  .object({
    nome,
    email,
    perfil: z.enum(PERFIS),
    ativo: z.boolean(),
  })
  .partial()
  .refine((v) => Object.keys(v).length > 0, { error: "Nada para alterar" });
export type UsuarioEditarEntrada = z.input<typeof usuarioEditarSchema>;

export const redefinirSenhaSchema = z.object({ senhaTemporaria: senhaNova });
export type RedefinirSenhaEntrada = z.input<typeof redefinirSenhaSchema>;
